<div>
  <div class="row-no-margin section-header-container" style="padding-bottom:10px;">
    <div class="col-md-6 clear-padding">
      <span class="section-header">Info Center</span>
    </div>
    <div class="col-md-5" style="text-align:right;">
      <button *ngIf="CurUser.IsTolomaticUser" class="blue" (click)="AddNewFile()" value="New File">New File</button>
      &nbsp;
      <button *ngIf="CurUser.IsTolomaticUser" class="blue" (click)="AddCategory()" value="New Category">New Category</button>
    </div>
  </div>
  <div class="row-no-margin">
    <div class="col-md-3">
      <span class="section-header-md">Filter</span>
      <div style="border-top:1px solid #808080">
        <div class="filterSection">
          <div class="font-weight-bold">
            File Name
          </div>
          <div class="col-md-12">
            <!--<mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
    <mat-label>File Name</mat-label>
    <input class="mat-focused" [(ngModel)]="FileNameFilter.Value" id="txtDescription" />
  </mat-form-field>-->
            <input type="text" (blur)="FileNameFilter_Blur()" [(ngModel)]="FileNameFilter.Value" id="txtDescription" />
          </div>
        </div>
        <div class="filterSection">
          <div class="font-weight-bold">Doc Type</div>          
          <app-category-tree *ngFor="let category of RootCategories" [cat]="category" [IsTolomaticUser]="CurUser.IsTolomaticUser" (EditCategoryClick)="EditCategory($event)">
            <!--<input style="max-width:80%;" type="checkbox" name="chkDocType" id="chk_{{docType.Desc}}" [checked]="docType.Selected" (change)="chkDocType_Change(docType)" />
            <label for="chk_{{docType.Desc}}">{{docType.Desc}}</label>
            <span style="line-height:22px;vertical-align:top;">
              <fa-icon *ngIf="CurUser.IsTolomaticUser" [icon]="faPenToSquare" (click)="EditCategory(docType.Value)" class="fa-light  clickable blue-color"></fa-icon> &nbsp; <fa-icon *ngIf="CurUser.IsTolomaticUser" [icon]="faX" (click)="DeleteCategory(docType.Value)" class="fa-light clickable blue-color"></fa-icon>
            </span>-->
          </app-category-tree>
        </div>
        <!--<div class="filterSection">
          <div class="font-weight-bold">File Type</div>
          <div *ngFor="let fileType of FileTypeList" style="width: 100%;">
            <input style="max-width:80%;" type="checkbox" name="chkFileType" id="chk_{{fileType.Value}}" [checked]="fileType.checked" (change)="chkFileType_Change(fileType)" />
            <label for="chk_{{fileType.Value}}">{{fileType.Desc}}</label>
          </div>
        </div>-->
      </div>   
  </div>
    <div cdkDropList class="col-md-9" (cdkDropListDropped)="FileDropped($event)">
      <div cdkDrag [cdkDragData]="{type:'cat',data:cat}" *ngFor="let cat of RootCategories | sort: 'SortOrder'" [hidden]="GetCatVisibility(cat)" class="col-md-12">
        <app-category-accordian [cat]="cat" [CurUser]="CurUser" (EditFileClick)="EditFile($event)" (RemoveFileClick)="RemoveFile($event)">

        </app-category-accordian>
       
        <!--<mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
        </mat-paginator>-->
      </div>
    </div>

  </div>
 
</div>
